
declare var Object: any;
export interface FacilitySignatureStatsInterface {
  "id"?: string;
  "vdate"?: any;
  "tenantId": number;
  "consumerId"?: number;
  "count": number;
}

export class FacilitySignatureStats implements FacilitySignatureStatsInterface {
  "id": string;
  "vdate": any;
  "tenantId": number;
  "consumerId": number;
  "count": number;
  constructor(data?: FacilitySignatureStatsInterface) {
    Object.assign(this, data);
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `FacilitySignatureStats`.
   */
  public static getModelName() {
    return "FacilitySignatureStats";
  }

  /**
  * This method creates an instance of FacilitySignatureStats for dynamic purposes.
  **/
  public static factory(data: FacilitySignatureStatsInterface): FacilitySignatureStats{
    return new FacilitySignatureStats(data);
  }

  /**
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'FacilitySignatureStats',
      plural: 'FacilitySignatureStats',
      path: 'FacilitySignatureStats',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "vdate": {
          name: 'vdate',
          type: 'any'
        },
        "tenantId": {
          name: 'tenantId',
          type: 'number'
        },
        "consumerId": {
          name: 'consumerId',
          type: 'number'
        },
        "count": {
          name: 'count',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
